import { css } from "styled-components";

import { controlTransition } from "../foundations/controlStyles";

export const MEDIA_FULLSCREEN_BUTTON_ATTR = "data-c6-media-fullscreen-button";

const fullscreenButtonSelector = `[${MEDIA_FULLSCREEN_BUTTON_ATTR}]`;

/**
 * Frame-level reveal policy for the `MediaFullscreenButton` preset.
 *
 * Keep the native button in the accessibility tree and tab order: only opacity changes.
 * The parent frame owns hover/focus-within, so the same mixin is shared by MediaFrame and
 * ZoomPanWrapper's non-transformed viewport.
 */
export const mediaFullscreenButtonRevealCss = css`
  ${fullscreenButtonSelector} {
    opacity: 1;
    ${controlTransition("opacity")}
  }

  @media (hover: hover) {
    &:not(:hover):not(:focus-within) ${fullscreenButtonSelector} {
      opacity: 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    ${fullscreenButtonSelector} {
      transition: none;
    }
  }
`;
